/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.73"
        height="71.53"
        viewBox="0 0 82.73 71.53"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M6.9 18.46a1.5 1.5 0 0 1 2.23 2h-.06a21.88 21.88 0 0 0 15.45 37h33.29a1.502 1.502 0 1 1 .15 3H24.88a24.88 24.88 0 0 1-18-42.07Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M57.81 10.73a24.87 24.87 0 0 1 16.51 43.53 1.49 1.49 0 0 1-2.12-.12 1.51 1.51 0 0 1 .12-2.12 21.88 21.88 0 0 0-14.15-38.27H24.88a1.502 1.502 0 0 1-.14-3Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M32.1.4a1.51 1.51 0 0 1 2.12.08 1.49 1.49 0 0 1 .1 1.92l-.1.11-9.72 9.75 9.92 9.92a1.48 1.48 0 0 1 .1 2l-.1.12a1.49 1.49 0 0 1-2 .1l-.11-.1-11-11a1.51 1.51 0 0 1-.1-2l.1-.11Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M48.48 47.26a1.51 1.51 0 0 1 2-.1l.11.1 10.78 10.77a1.49 1.49 0 0 1 .11 2l-.11.11-11 11a1.49 1.49 0 0 1-2.12 0 1.51 1.51 0 0 1-.11-2l.11-.11 9.91-9.92-9.68-9.73a1.51 1.51 0 0 1-.1-2Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'TwoRevolvingArrowsOvalIcon';

export default Icon;
